export default __webpack_public_path__ + "static/media/logo-colored.5333f2ec.png";